import { IBoolTermFieldSchema } from '../../repositories/newbuilding-promos/entities/json_query/BoolTermFieldSchema';
import { EJsonQueryType, IJsonQueryTerm } from '../../types/jsonQuery/term';

export function mapJsonQueryBoolTerm(term?: IBoolTermFieldSchema | null): IJsonQueryTerm<boolean> | null {
  if (!term) {
    return null;
  }

  return {
    type: EJsonQueryType.Term,
    value: term.value,
  };
}
